import mod from "-!./result_team.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./result_team.js?vue&type=script&lang=js&external"